import { __awaiter, __decorate, __extends, __generator } from "tslib";
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import NavPanel from '@/components/common/NavPanel.vue';
import { PageService } from '@/views/copy/thirdBind/import';
import AvalonGTGlobal from '@/utils/factory/Global';
import { Toast } from 'vant';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputErr = ''; //  2024-01-26 10:10:31：绑定错误提醒信息
        _this.accredit = ''; //  2024-02-02 10:37:11：支付宝授权code
        _this.timer = null;
        _this.isUser = true; //  2024-02-01 11:06:11：是否是普通用户
        _this.info = {
            account: '',
            name: '',
            idNumber: '',
            isLabourWithdraw: 0,
        };
        return _this;
    }
    View.prototype.created = function () {
        var _this = this;
        ;
        window['getAliSign'] = function (params) {
            _this.getAliSign(params);
        };
        this.userSimpleInfo();
        this.$watch('info.idNumber', this.examine2, {
            deep: true,
        }); //  2024-01-26 10:29:07：启动输入值监听判断是否输入合法值
        this.$watch('info.account', this.examine, {
            deep: true,
        }); //  2024-01-26 10:29:07：启动输入值监听判断是否输入合法值
    };
    View.prototype.mounted = function () {
        this.userAlipayAccounts();
    };
    //  2024-01-26 10:10:16：联系客服
    View.prototype.linkService = function () {
        this.awlGlobalConfig.gotoKfService();
    };
    // 重定向验证手机号函数
    // private Redirect(isUser: any) {
    //     if (isUser && !this.$route.query.isVer) {
    //         // this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1)
    //         //  2025-01-15 14:13:54：超推用户需前往手机号验证
    //         this.$router.replace({
    //             path: '/nav/smsVerify',
    //             query: this.$route.query,
    //         })
    //     }
    // }
    View.prototype.userAlipayAccounts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, PageService.userAlipayAccounts()
                        // this.Redirect(data.isLabourWithdraw)
                    ];
                    case 1:
                        data = _a.sent();
                        // this.Redirect(data.isLabourWithdraw)
                        this.info.isLabourWithdraw = data.isLabourWithdraw;
                        this.isUser = this.info.isLabourWithdraw == 0;
                        return [2 /*return*/];
                }
            });
        });
    };
    View.prototype.isVbs = function () {
        if (this.info.account && this.info.name && !this.inputErr && this.info.idNumber) {
            return true;
        }
        else {
            return false;
        }
    };
    View.prototype.getAliSign = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('getAliSign授权信息', params);
                        this.accredit = params;
                        if (!this.accredit) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.bind(this.accredit)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        Toast('授权失败，请重新绑定');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    //  2024-02-01 11:06:11：获取用户实名信息
    View.prototype.userSimpleInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, PageService.userSimpleInfo()];
                    case 1:
                        data = _a.sent();
                        this.info.name = data.trueName;
                        this.info.idNumber = data.idNumber;
                        return [2 /*return*/];
                }
            });
        });
    };
    //  2024-01-26 10:11:24：绑定
    View.prototype.submit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isVbs()) return [3 /*break*/, 2];
                        console.log(this.info);
                        //  2024-02-02 10:17:49：如果已经拿到授权code直接绑定即可
                        // if (this.accredit) {
                        return [4 /*yield*/, this.bind(this.accredit)
                            // } else {
                            // this.startAccredit() //  2024-02-01 12:01:21：启动授权
                            // }
                        ];
                    case 1:
                        //  2024-02-02 10:17:49：如果已经拿到授权code直接绑定即可
                        // if (this.accredit) {
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    //  2024-02-01 11:59:06：支付宝绑定操作
    View.prototype.bind = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Toast.loading({
                            message: '绑定中...',
                            forbidClick: true,
                        });
                        params = { realName: this.info.name, account: this.info.account, idNumber: this.info.idNumber };
                        // if (code) {
                        //     params.code = code
                        // }
                        return [4 /*yield*/, PageService.userAlipayBind(params)];
                    case 1:
                        // if (code) {
                        //     params.code = code
                        // }
                        _a.sent();
                        Toast.success({
                            duration: 4000,
                            forbidClick: true,
                            message: '绑定成功',
                        });
                        //  2024-02-01 18:57:20：回退页面
                        clearTimeout(this.timer);
                        this.timer = setTimeout(function () {
                            _this.rollBack();
                        }, 2000);
                        return [2 /*return*/];
                }
            });
        });
    };
    //  2024-02-01 11:59:16：通知安卓拉起支付宝授权
    View.prototype.startAccredit = function () {
        var params = {
            action: 16,
        };
        this.awlGlobalConfig.messageHandlers(params);
    };
    View.prototype.examine = function (nval) {
        if (nval.includes(' ')) {
            this.info.account = this.removeSpaces(nval);
        }
        var sj = /^(?:(?:\+|00)86)?1\d{10}$/;
        var yx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (AvalonGTGlobal.isChinese(nval)) {
            return (this.inputErr = '支付宝账号输入不合规，不应该包含中文');
        }
        if (sj.test(nval) || yx.test(nval)) {
            return (this.inputErr = '');
        }
        return (this.inputErr = '请输入本人支付宝绑定的手机号或者邮箱');
    };
    View.prototype.examine2 = function (nval) {
        if (nval.includes(' ')) {
            this.info.idNumber = this.removeSpaces(nval);
        }
        var rg = /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/;
        if (AvalonGTGlobal.isChinese(nval)) {
            return (this.inputErr = '请输入正确的身份证号码，不应该包含中文');
        }
        if (rg.test(nval)) {
            return (this.inputErr = '');
        }
        return (this.inputErr = '请输入正确的身份证号码');
    };
    View = __decorate([
        Options({ components: { NavPanel: NavPanel } })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
